import styles from './give-recurring-support.module.less';
import { Link } from 'react-router';
import { useState } from 'react';
import { InlineExpandButton } from '@sb1/ffe-buttons-react';
import List from '../../../components/text/List';
import { Collapse } from '@sb1/ffe-collapse-react';

const GiveRecurringPaymentDisclaimer = ({ organizationName }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={styles.recurringPaymentInfo}>
            <p className={styles.compactInfoHeading}>
                Ved å bli fast giver aksepterer du Spleis sine <Link to="/terms">vilkår for bruk</Link> og{' '}
                <Link to="/personvern">personvernerklæring</Link>. Dine kontaktopplysninger vil også deles med{' '}
                {organizationName}.{' '}
                <InlineExpandButton isExpanded={expanded} onClick={() => setExpanded(!expanded)}>
                    Vis mer
                </InlineExpandButton>
            </p>
            <Collapse isOpen={expanded} role="region">
                <p>Følgende opplysninger deles med mottakerorganisasjonen:</p>
                <List className={styles.recurringPaymentExtraInfoDataList}>
                    <li>Navnet ditt</li>
                    <li>E-postadresssen din</li>
                    <li>Telefonnummeret ditt</li>
                </List>
                <p>Mottakerorganisasjonen er ansvarlig for behandlingen av dine personopplysninger.</p>
                <p>
                    Fremtidige trekk kan når som helst endres fra Vipps-appen, eller ved å kontakte{' '}
                    <Link to="mailto:hei@spleis.no">hei@spleis.no</Link>
                </p>
            </Collapse>
        </div>
    );
};

export default GiveRecurringPaymentDisclaimer;
